import { Modal, List } from "antd";

import { clamp } from "../../../utils/responsiveHelpers";

const ReferrerEventsViewModal = ({
  referrerEventLogs = [],
  isModalOpen = false,
  setIsModalOpen = () => {}
}) => {
  const handleOk = () => {
    setIsModalOpen(false);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };

  return (
    <Modal
      title="Referrer Events"
      open={isModalOpen}
      footer={[]}
      width={2500}
      onOk={handleOk}
      onCancel={handleCancel}
    >
      <div
        style={{
          marginTop: "20px",
          marginLeft: clamp(12, 30),
          marginRight: clamp(12, 30)
        }}
      >
        <List
          header={<div>Referrer Events</div>}
          bordered
          dataSource={referrerEventLogs || []}
          renderItem={(eventLog) => <List.Item>{eventLog}</List.Item>}
        />
        <br />
      </div>
    </Modal>
  );
};

export default ReferrerEventsViewModal;
